import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CCard, CCardBody, CButton, CCardHeader } from '@coreui/react';

import { callTokenApi } from '../../../../../../../apiCaller';
import { toastError } from '../../../../../../../utils';
import { API_CLIENT_RULE_UPDATE, LISTENER_TYPE } from '../../../../../../../constants';
import { SelectListenerRule } from '../../../../../../general/rules';

import { RuleContext } from './CreateFormCrawlRule';
import { setSubscriberState } from '../../../../../../../actions/subscriber';
import { setFetchRule, setRuleHaveEditting, setViewedRule } from '../../../../../../../actions/common';

const Step1 = ({ actionType }) => {
     const dispatch = useDispatch();
     const { rule, activeStep, setRule, setActiveStep } = useContext(RuleContext);

     const selectedListenerRule = useSelector((state) => state.subscriber.selectedListenerRule);
     const formCrawlRules = useSelector((state) => state.subscriber.formCrawlRules);

     const [saveLoading, setSaveLoading] = useState(false);

     const isEditing = actionType === 'edit';

     const initialValues = {
          listenerId: rule?.listenerId,
     };

     const fetchSelectListener = () => {
          if (selectedListenerRule == null && !!initialValues.listenerId) {
               dispatch(setSubscriberState({ selectedListenerRule: initialValues.listenerId }));
          }
     };
     useEffect(fetchSelectListener, [selectedListenerRule]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleSaveAndNextStep = () => {
          // Create mode
          if (!isEditing) {
               setActiveStep(2);
               return;
          }

          // Update mode
          const data = {
               listenerId: selectedListenerRule,
          };

          if (JSON.stringify(initialValues) === JSON.stringify(data)) {
               setActiveStep(2);
               return;
          }

          const newStepsData = { ...rule, ...data };

          setSaveLoading(true);
          callTokenApi(API_CLIENT_RULE_UPDATE, 'POST', newStepsData).then((response) => {
               setSaveLoading(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               setRule(newStepsData);
               const updateData = formCrawlRules?.filter((crawlRule) => crawlRule.id !== newStepsData.id) || [];
               updateData.push(newStepsData);
               dispatch(setSubscriberState({ formCrawlRules: updateData }));
               dispatch(setViewedRule(null, true));
               dispatch(setRuleHaveEditting({ showLv2: false, typeLv2: '' }));
               dispatch(setFetchRule());
               setActiveStep(2);
          });
     };

     return (
          <CCard className={`cvr-step-1 ${activeStep === 1 ? 'cvr-step-card' : 'difference-step'}`}>
               <CCardHeader>
                    {activeStep === 1 ? (
                         <h5>Step 1: Select Listener Form</h5>
                    ) : (
                         <div className="rule-step d-inline-flex justify-content-between align-items-center w-100">
                              <h5 className="mb-0 inactive">Step 1: Listener Form</h5>
                              <CButton className="btn-edit" onClick={() => setActiveStep(1)}>
                                   Edit
                              </CButton>
                         </div>
                    )}
               </CCardHeader>
               <CCardBody className={`${activeStep !== 1 ? 'd-none' : ''}`}>
                    <SelectListenerRule listenerType={LISTENER_TYPE.FORMS} />
                    <CButton className="px-4" color="primary" disabled={!selectedListenerRule || saveLoading} onClick={handleSaveAndNextStep}>
                         {isEditing ? 'SAVE & NEXT' : 'NEXT STEP'}
                    </CButton>
               </CCardBody>
          </CCard>
     );
};

Step1.propTypes = {
     actionType: PropTypes.string,
};

export default Step1;
